import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import LiveChatList from 'common/components/modules/chat/notifications-list'
// import { push } from 'connected-react-router';
import ModalDropDown from  'common/components/modules/chat/chat-modal-drop-down'

const ChatNotification = ({
   isMobile,
   list,
   onClickChat,
   showOnlineMembers,
   onCloseModal,
   isFetchingInit,
   showOnlineMembersButton,
   authUser,
   openChatDropDown,
   closeChatDropDown,
   onReadMessage,
   showNavigationList,
   adminUuid,
   siteInfo,
}) => {
   const [animate, setAnimate] = useState(null)
   let timeout = null
   useEffect(() => {
      return () => {
         clearTimeout(timeout)
      };
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);
   return (
      <ModalDropDown
         tooltipId={ isMobile ? null : 'site-chat-notification' }
         isMobile={ isMobile }
         isSite={ true }
         onCloseModal={ () => {
            setAnimate('down')
            timeout = setTimeout(() => {
               onCloseModal(false)
               setAnimate(null)
            }, 800)
         } }
         contentPosition='bottom'
         openChatDropDown={ openChatDropDown }
         closeChatDropDown={ closeChatDropDown }
         animate={ animate || 'up' }
         isOpen={ showNavigationList }

      >
         <div
            className='h-full w-full'>
            <LiveChatList
               list={ list }
               onClickChat={ (data) => {
                  if(!!data.user_uuid) {
                     onReadMessage(data)
                  }
                  onClickChat(data)
               } }
               buttonText='Who is online?'
               onClickButton={ showOnlineMembers }
               isMobile={ isMobile }
               isFetchConversation={ isFetchingInit }
               onlyTwoConvestaion
               showButton={ showOnlineMembersButton }
               showHelpIcon={ isMobile }
               authUser={ authUser }
               adminUuid={ adminUuid }
               siteInfo={ siteInfo }
            />
         </div>
      </ModalDropDown>
   )
}
ChatNotification.propTypes = {
   isMobile: PropTypes.bool,
   list: PropTypes.array,
   onClickChat: PropTypes.func,
   showOnlineMembers: PropTypes.func,
   onCloseModal: PropTypes.func,
   isFetchingInit: PropTypes.bool,
   showOnlineMembersButton: PropTypes.bool,
   authUser: PropTypes.object,
   openChatDropDown: PropTypes.func,
   closeChatDropDown: PropTypes.func,
   onReadMessage: PropTypes.func,
   showNavigationList: PropTypes.bool,
   adminUuid: PropTypes.string,
   siteInfo: PropTypes.object,
}
export default ChatNotification;
